import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { getString } from './helpers';
import { Globe, Loader2, ExternalLink, AlertTriangle } from 'lucide-react';

export const VisaTab = ({
  visaData,
  loadingVisa,
  generatedItinerary,
  fetchVisaInfo,
  trip_input,
}) => {
  return (
    <div className="space-y-6">
      {loadingVisa ? (
        <div className="flex items-center justify-center p-12"><Loader2 className="w-8 h-8 animate-spin text-ocean" /></div>
      ) : visaData ? (
        <>
          <Card className={`bg-white/95 backdrop-blur-xl border-2 ${visaData.visa_required ? 'border-red-200' : 'border-green-200'}`}>
            <CardContent className="p-6">
              <div className="flex items-center gap-4 mb-4">
                <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${visaData.visa_required ? 'bg-red-100' : 'bg-green-100'}`}>
                  <Globe className={`w-7 h-7 ${visaData.visa_required ? 'text-red-600' : 'text-green-600'}`} />
                </div>
                <div>
                  <h3 className="font-serif text-xl text-charcoal">
                    {visaData.visa_required ? 'Visa Required' : 'Visa-Free Entry'}
                  </h3>
                  {visaData.visa_type && <p className="text-ocean">{visaData.visa_type}</p>}
                </div>
              </div>
              <div className="grid md:grid-cols-3 gap-4">
                {visaData.max_stay && (
                  <div className="bg-sky/5 p-4 rounded-xl"><p className="text-xs text-ocean/60 mb-1">Max Stay</p><p className="font-semibold text-ocean">{visaData.max_stay}</p></div>
                )}
                {visaData.processing_time && (
                  <div className="bg-gold/5 p-4 rounded-xl"><p className="text-xs text-ocean/60 mb-1">Processing Time</p><p className="font-semibold text-ocean">{visaData.processing_time}</p></div>
                )}
                {visaData.cost && (
                  <div className="bg-burnt/5 p-4 rounded-xl"><p className="text-xs text-ocean/60 mb-1">Visa Cost</p><p className="font-semibold text-ocean">{visaData.cost}</p></div>
                )}
              </div>
            </CardContent>
          </Card>
          {visaData.documents_required && (
            <Card className="bg-white/95 backdrop-blur-xl border-white/30 shadow-xl">
              <CardHeader><CardTitle className="font-serif text-lg text-ocean">Required Documents</CardTitle></CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {visaData.documents_required.map((doc, i) => (
                    <li key={`visa-doc-${doc.slice(0,20)}-${i}`} className="flex items-start gap-2 text-sm text-charcoal"><span className="text-ocean mt-0.5">&#10003;</span>{doc}</li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          )}
          {visaData.application_url && visaData.application_url !== 'N/A' && visaData.application_url !== 'n/a' && !visaData.application_url.includes('N/A') && (
            <Card className="bg-white/95 backdrop-blur-xl border-ocean/20 shadow-lg">
              <CardContent className="p-6 flex items-center justify-between">
                <div>
                  <h4 className="font-semibold text-ocean">Apply for Visa Online</h4>
                  <p className="text-amber-600 text-xs mt-1">AI-suggested link - please verify with official government sources before applying</p>
                </div>
                <a href={visaData.application_url} target="_blank" rel="noopener noreferrer">
                  <Button className="bg-ocean hover:bg-ocean-light text-white rounded-full">
                    <ExternalLink className="w-4 h-4 mr-2" /> Visit Link
                  </Button>
                </a>
              </CardContent>
            </Card>
          )}
          {visaData.notes && (
            <Card className="bg-amber-50/80 border-amber-200">
              <CardContent className="p-6">
                <p className="text-sm text-amber-800 flex items-start gap-2"><AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0" />{visaData.notes}</p>
              </CardContent>
            </Card>
          )}
        </>
      ) : generatedItinerary.visa_info ? (
        <Card className="bg-white/95 backdrop-blur-xl border-white/30 shadow-xl">
          <CardHeader><CardTitle className="font-serif text-lg text-ocean">Visa Information</CardTitle></CardHeader>
          <CardContent>
            <p className="text-sm text-charcoal mb-4">{getString(generatedItinerary.visa_info)}</p>
            <Button onClick={() => fetchVisaInfo(trip_input.nationality, `${trip_input.destination_city}, ${trip_input.destination_country}`)}
              className="bg-ocean hover:bg-ocean-light text-white rounded-full" data-testid="load-visa-details-btn">
              <Globe className="w-4 h-4 mr-2" /> Get Detailed Visa Info & Apply Link
            </Button>
          </CardContent>
        </Card>
      ) : (
        <Card className="bg-white/95 backdrop-blur-xl border-white/30 shadow-xl">
          <CardContent className="p-8 text-center">
            <Globe className="w-12 h-12 text-ocean/30 mx-auto mb-4" />
            <p className="text-ocean/50 mb-4">Load visa requirements for your destination</p>
            <Button onClick={() => fetchVisaInfo(trip_input.nationality, `${trip_input.destination_city}, ${trip_input.destination_country}`)}
              className="bg-ocean hover:bg-ocean-light text-white rounded-full" data-testid="load-visa-btn">
              <Globe className="w-4 h-4 mr-2" /> Check Visa Requirements
            </Button>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
